import { Stack, Switch, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

export default function ShowExitRow() {
	const { values, actions } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack flexDirection={"row"} alignItems={"center"} justifyContent='space-between'>
			<Typography variant='body1' fontSize={14} color='text.secondary'>
				{translate("Mostrar botón de salida")}
			</Typography>
			<Switch
				color='primary'
				size='small'
				onChange={() => actions.setValue("showExit", !values.showExit)}
				checked={values.showExit}
			/>
		</Stack>
	);
}
